export enum CalculationTypeEnum {
  AtHome = 'atHome',
  Automation = 'automation',
  HeatingInstallation = 'heatingInstallation',
  SanitaryInstallation = 'sanitaryInstallation',
  Reguard = 'reguard',
  Resource = 'resource',
  Renovation = 'renovation',
}
